import Header from '@editorjs/header'
import Embed from '@editorjs/embed'
import Image from '@editorjs/image'
import Table from '@editorjs/table'
import List from '@editorjs/list'
import Warning from '@editorjs/warning'
import LinkTool from '@editorjs/link'
import Quote from '@editorjs/quote'
import Marker from '@editorjs/marker'
import CheckList from '@editorjs/checklist'
import Delimiter from '@editorjs/delimiter'
import SimpleImage from '@editorjs/simple-image'

const EditorJSTools = {
    embed: Embed,
    table: Table,
    marker: Marker,
    list: List,
    warning: Warning,
    linkTool: LinkTool,
    image: Image,
    header: Header,
    quote: Quote,
    checklist: CheckList,
    delimiter: Delimiter,
    simpleImage: SimpleImage,
}

export{EditorJSTools}

/*
window.jQuery = jquery;
window.$ = jquery;
*/

window.ResetPositionScrollbarOptionsBar = function ResetPositionScrollbarOptionsBar(handler) {
    for (let i = 0; i < handler.length; i++) {
        handler[i].scrollLeft = 0;
    }
}

/* --------------------------------------------------------
    Show Modal On Timer (5")
-------------------------------------------------------- */
function ShowBanner(){
    return new Promise((resolve, reject) => {
        setTimeout(function() {
            $('#modal_newsletter_popup').modal('show');
            resolve();
        }, 5000);
    })
}

jQuery(function(){

    if (!sessionStorage.getItem('yetVisited')) {
        //console.log("Showing banner in 5 sec...")
        ShowBanner()
            .then((response) => {
                sessionStorage.setItem('yetVisited', "yes");
            })
            .catch(() => {
                ShowGenericErrorModal();
            })
    }
})

/*
*/

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

const PromiseAjaxPostForm = function ($form){
    return new Promise((resolve, reject) => {
        $.ajax({
            headers: {'X-CSRFToken': getCookie('csrftoken')},
            method: "POST", 
            url: $form.attr('action'),
            data: $form.serialize(),
            success: function (ajax_data){
                resolve($(ajax_data))
            },
            error: function(error){
                //console.log("Error with First POST request sent....")
                reject(error)
            }
        }) 
    })
}
export {PromiseAjaxPostForm};

const PromiseAjaxGet = function (url){
    return new Promise((resolve, reject) => {

        $.ajax({
            method: "GET", 
            url: url,
            success: function (ajax_data){
                resolve($(ajax_data))
            },
            error: function(error){
                reject(error)
            }
        }) 
    })
}
export {PromiseAjaxGet};

const ReplaceAjax = function ($ajax_data){

    var els = $("*[id^='ajax_reload']");
    var d = []
    for (let j=0; j<els.length; j++){
        var el_id = $(els[j]).attr("id");
        var ajax_el = $ajax_data.find("#"+el_id);
        $(els[j]).html($(ajax_el).html());
    }; 
}
export {ReplaceAjax};
